export const normalizeEntityType = (t) => {
  const s = String(t || "")
    .trim()
    .toLowerCase();
  if (s === "organisation") return "organization";
  if (s === "org" || s === "org-unit" || s.includes("org unit"))
    return "organization";
  if (s.includes("applicationinterface")) return "interface";
  if (s.includes("application component") || s.includes("applicationcomponent"))
    return "application";
  if (
    s.includes("technologycomponent") ||
    s.includes("itcomponent") ||
    s.includes("it component")
  )
    return "technology-component";
  if (s.includes("dataobject") || s.includes("data object"))
    return "data-object";
  if (s.includes("businesscapability") || s.includes("business capability"))
    return "business-capability";
  if (s.includes("businesscontext") || s.includes("business context"))
    return "business-context";
  if (s === "solution-component" || s.includes("solution component"))
    return "solution-component";
  // Ensure platform is normalized correctly
  if (s === "platform" || s.includes("platform")) return "platform";
  return s;
};

/** True when entity (or type string) is an Application — not interface or solution-component. */
export const isApplicationEntity = (entityOrType) => {
  if (entityOrType && typeof entityOrType === "object") {
    const normalized = normalizeEntityType(
      entityOrType.type || entityOrType.entity_type || ""
    );
    if (normalized === "application") return true;
    const raw = String(entityOrType.type || entityOrType.entity_type || "")
      .trim()
      .toLowerCase();
    return (
      (raw.includes("applicationcomponent") || raw === "application") &&
      !raw.includes("interface")
    );
  }
  return normalizeEntityType(entityOrType) === "application";
};

export const normalizeRelTypeTokens = (relType) => {
  const s = String(relType || "").toLowerCase();
  // split by non-alpha
  return s.split(/[^a-z]+/).filter(Boolean);
};
